import API from '../../../utils/API';
import { Post, Get, Put, Patch, Delete } from '../../../utils/callApi';

const ITEM_PER_PAGE = 10;

const changeDateToString = (date) => {
  return ("0" + date.getDate()).slice(-2) + "/" + ("0" + (date.getMonth() + 1)).slice(-2) + "/" +date.getFullYear();
}

export const getListUser = async (body) => {
  const {project, page} = body;
  const {success, data} = await Get(API.USER.GET_USERS(project, page, ITEM_PER_PAGE));

  if(success) {
    if(data.ErrorCode === 0){
      const list_user = data.Result.docs.map((e) => {
        return {
          ...e,
          update_date: changeDateToString(new Date(e.update_date))
        }
      })

      return {
        success: true,
        data: {
          users: list_user,
          page: Number(data.Result.page),
          totalPage: Number(data.Result.pages),
          totalUsers: Number(data.Result.total),
        }
      }
    }
    return {
      success: false,
      data: {error: data.Message}
    }
  } else {
    return {
      success: false,
      data: {}
    }
  }
}

export const addNewUser = async (body) => {
  
  const {email, name, phone, department} = body;

  const {success, data} = await Post(API.USER.CREATE_USER_INFO, {
    email: email,
    sdt: phone,
    fullName: name,
    department: department,
  });

  if(success) {
    if(data.ErrorCode === 0) {
      const {project, role} = body;
      const {success, data} = await Post(API.USER.ADD_PERMISSION, {
        email: email,
        api_key: project.api_key,
        role_code: Number(role),
      });

      if(success) {
        if(data.ErrorCode === 0) {
          return getListUser({project: project.account_name, page: 1});
        }

        if(data.ErrorCode === 400) {
          return {
            success: false,
            data: {error: "Bạn không được phân quyền cho người có vai trò tương tự hoặc cao hơn bạn."}
          }
        }

        if(data.ErrorCode === 403) {
          return {
            success: false,
            data: {error: "Người dùng đã tham gia dự án trước đó."}
          }
        }

        if(data.ErrorCode === 410) {
          if(data.Message.toLowerCase().includes('email')) {
            return {
              success: false,
              data: {error: "Người dùng không tồn tại."}
            }
          } else {
            return {
              success: false,
              data: {error: "Dự án không tồn tại."}
            }
          }
        }

        return {
          success: false,
          data: {error: data.Message}
        }
      } else {
        return {
          success: false,
          data: {}
        }
      }
    }
    return {
      success: false,
      data: {error: data.Message}
    }
  } else {
    return {
      success: false,
      data: {}
    }
  }
}

export const editAUser = async (body) => {
  const {email, name, phone, department} = body;

  const {success, data} = await Post(API.USER.CREATE_USER_INFO, {
    email: email,
    sdt: phone,
    fullName: name,
    department: department,
  });

  if(success) {
    if(data.ErrorCode === 0) {
      const {project, role} = body;
      const {success, data} = await Patch(API.USER.EDIT_PERMISSION, {
        email: email,
        api_key: project.api_key,
        role_code: Number(role),
      });

      if(success) {
        if(data.ErrorCode === 0) {
          return getListUser({project: project.account_name, page: 1});
        }

        if(data.ErrorCode === 400) {
          return {
            success: false,
            data: {error: "Bạn không được phân quyền cho người có vai trò tương tự hoặc cao hơn bạn."}
          }
        }

        if(data.ErrorCode === 410) {
          if(data.Message.toLowerCase().includes('role')) {
            return {
              success: false,
              data: {error: "Vai trò không tồn tại."}
            }
          } else {
            return {
              success: false,
              data: {error: "Người dùng chưa được thêm vào dự án."}
            }
          }
        }

        return {
          success: false,
          data: {error: data.Message}
        }
      } else {
        return {
          success: false,
          data: {}
        }
      }
    }
    return {
      success: false,
      data: {error: data.Message}
    }
  } else {
    return {
      success: false,
      data: {}
    }
  }
}

export const deleteAUser = async (body) => {
  const {email, project} = body;

  const {success, data} = await Post(API.USER.DELETE_USER, {
    email: email,
    api_key: project.api_key,
  });

  if(success) {
    if(data.ErrorCode === 0) {
      return getListUser({project: project.account_name, page: 1});
    }

    if(data.ErrorCode === 400) {
      return {
        success: false,
        data: {error: "Bạn không được xóa người có vai trò tương tự hoặc cao hơn bạn."}
      }
    }

    if(data.ErrorCode === 410) {
      if(data.Message.toLowerCase().includes('email')) {
        return {
          success: false,
          data: {error: "Người dùng không tồn tại."}
        }
      } else {
        if(data.Message.toLowerCase().includes('user in project')){
          return {
            success: false,
            data: {error: "Người dùng không tồn tại trong dự án."}
          }
        } else {
          return {
            success: false,
            data: {error: "Dự án không tồn tại."}
          }
        }
      }
    }

    return {
      success: false,
      data: {error: data.Message}
    }
  } else {
    return {
      success: false,
      data: {}
    }
  }
}

export const exportDataUser = async (body) => {
 
  const {project, page} = body;
  const {success, data} = await Get(API.USER.GET_USERS(project, page, ITEM_PER_PAGE));

  if(success) {
    if(data.ErrorCode === 0){
      const list_user = data.Result.docs.map((e) => {
        return {
          ...e,
          update_date: changeDateToString(new Date(e.update_date))
        }
      })
      return {
        success: true,
        data: {
          exportData: list_user,
          exportPercent: page * 100 / Number(data.Result.pages)
        }
      }
    }
    return {
      success: false,
      data: {}
    }
  } else {
    return {
      success: false,
      data: {}
    }
  }
}

export const autoCompleteUser = async (email) => {
  const { success, data } = await Get(API.USER.AUTO_COMPLETE + `?email=${email}`);

  if(success) {
    if(data.ErrorCode === 0){
      return {
        success: true,
        data: data.Result,
      }
      ;
    }
    return {
      success: false,
      data: []
    }
  } else {
    return {
      success: false,
      data: []
    }
  }
}

export const autoCompleteDepartment = async (key_search) => {
  const { success, data } = await Get(API.USER.AUTO_COMPLETE_DEPARTMENT(key_search));

  if(success) {
    if(data.ErrorCode === 0){
      return {
        success: true,
        data: data.Result,
      };
    }
    return {
      success: false,
      data: []
    }
  } else {
    return {
      success: false,
      data: []
    }
  }
}

export const getListProjectOfUser = async (typeProject)  => {
  const { success, data } = await Get(API.USER.GET_LIST_PROJECT_OF_USER(typeProject));

  if(success) {
    if(data.ErrorCode === 0){
      return {
        success: true,
        data: data.Result,
      }
      ;
    }
    return {
      success: false,
      data: []
    }
  } else {
    return {
      success: false,
      data: []
    }
  }
}

export const getListRoleForPermission = async (apiKey) => {
  const { success, data } = await Get(API.USER.GET_LIST_ROLE(apiKey));

  if(success) {
    if(data.ErrorCode === 0){
      return {
        success: true,
        data: data.Result,
      }
      ;
    }
    return {
      success: false,
      data: []
    }
  } else {
    return {
      success: false,
      data: []
    }
  }
}